import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=8c1b887a&"
import script from "./Budgets.vue?vue&type=script&lang=js&"
export * from "./Budgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports